import { TextFieldWrapper } from "../style/ConditionSelector.styled";

export default function TextFieldView () {
    return (
        <TextFieldWrapper>
            <div>* 검색 기간 내에 판매된 상품의 카테고리가 조회됩니다.</div>
            <div>* 카테고리를 선택해 상품 순위를 확인할 수 있습니다.</div>
        </TextFieldWrapper>
    )
}